if (!customElements.get('vendor-list')) {
  class VendorList extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey || 'vendor-list-view';
      this.viewButtons = Array.from(this.querySelectorAll('[data-view]'));
      this.filterButtons = Array.from(this.querySelectorAll('[data-filter-category]'));
      this.letterButtons = Array.from(this.querySelectorAll('[data-letter]'));
      this.gridCards = Array.from(this.querySelectorAll('[data-brand-card="grid"]'));
      this.listCards = Array.from(this.querySelectorAll('[data-brand-card="list"]'));
      this.groups = Array.from(this.querySelectorAll('[data-letter-group]'));
      this.countEl = this.querySelector('[data-brand-count]');

      this.view = this.getSavedView() || this.dataset.defaultView || 'grid';
      this.category = 'all';

      this.viewButtons.forEach((button) => {
        button.addEventListener('click', () => this.setView(button.dataset.view));
      });

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => this.setCategory(button.dataset.filterCategory));
      });

      this.letterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = this.querySelector(`#vendor-${button.dataset.letter}`);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      this.apply();
    }

    getSavedView() {
      if (window.Shopify && window.Shopify.designMode) return null;
      try {
        const saved = localStorage.getItem(this.storageKey);
        if (saved === 'grid' || saved === 'list') return saved;
      } catch (e) {
        /* storage unavailable */
      }
      return null;
    }

    setView(view) {
      if (!view || view === this.view) return;
      this.view = view;
      try {
        localStorage.setItem(this.storageKey, view);
      } catch (e) {
        /* storage unavailable */
      }
      this.apply();
    }

    setCategory(category) {
      this.category = category || 'all';
      this.apply();
    }

    apply() {
      this.setAttribute('data-view', this.view);

      this.viewButtons.forEach((button) => {
        const isActive = button.dataset.view === this.view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.filterButtons.forEach((button) => {
        const isActive = button.dataset.filterCategory === this.category;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const matchCard = (card) => this.category === 'all' || card.dataset.category === this.category;

      this.gridCards.forEach((card) => {
        card.hidden = !matchCard(card);
      });

      this.listCards.forEach((card) => {
        card.hidden = !matchCard(card);
      });

      this.groups.forEach((group) => {
        const hasVisible = group.querySelector('[data-brand-card="list"]:not([hidden])');
        group.hidden = !hasVisible;
      });

      this.letterButtons.forEach((button) => {
        const group = this.querySelector(`#vendor-${button.dataset.letter}`);
        const disabled = !group || group.hidden;
        button.classList.toggle('is-disabled', disabled);
        button.disabled = disabled;
      });

      const visibleCount = (this.view === 'list' ? this.listCards : this.gridCards).filter(matchCard).length;
      if (this.countEl) this.countEl.textContent = String(visibleCount);
    }
  }

  customElements.define('vendor-list', VendorList);
}
